import { Dropzone } from '@dropzone-ui/react';
import React, { useEffect } from 'react';
import {
	download_icon_small,
	delete_file_paiement_letter,
} from '../../../../../utils/images';

function BillComponent(props) {
	function updateFiles(incommingFiles) {
		let temp = props?.files;

		for (const [, value] of Object.entries(incommingFiles)) {
			let fileAlreadyInList = false;
			for (const [, v] of Object.entries(props?.files)) {
				if (v.name === value.name) fileAlreadyInList = true;
			}

			if (!fileAlreadyInList) temp[Object.keys(temp).length] = value;
		}

		props?.setFiles({ ...temp });
	}

	// Pour supprimer un file uploaded
	function onDeleteItem(key) {
		let temp = props?.files;

		delete temp[key];

		let tempCleanIndexes = {};

		for (const [, value] of Object.entries(temp))
			tempCleanIndexes[Object.keys(tempCleanIndexes).length] = value;

		props?.setFiles({ ...tempCleanIndexes });
	}

	// Fonction qui permet d'afficher les noms des fichiers dropped
	function getFileItems() {
		const fileItems = [];

		for (const [key, file] of Object.entries(props?.files)) {
			fileItems.push(
				<div className="list-files-container" key={key}>
					<span className="file-name">{file.name}</span>
					<img
						src={delete_file_paiement_letter}
						className="file-icon"
						alt="delete file icon"
						onClick={() => onDeleteItem(key)}
					/>
				</div>
			);
		}

		return fileItems;
	}

	useEffect(() => {}, [props.files]);

	return (
		<div>
			<div className="bill-element">
				<div className="modal-paiement-title">Factures</div>
				<Dropzone
					color="#4188F2"
					onChange={(incommingFiles) => updateFiles(incommingFiles)}
					header={false}
					footer={false}
					style={{
						fontFamily: 'Poppins regular',
						fontSize: '14px',
						border: 'none',
						backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='14' ry='14' stroke='%234188F2FF' stroke-width='2' stroke-dasharray='14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
					}}
					value={props?.files}
				>
					<div className="sd-container-img-label">
						<img
							className="img-dwnld"
							src={download_icon_small}
							alt="downlad icon small"
						></img>
						<div className="sd-dropzone-title">Déposer mes factures</div>
					</div>
				</Dropzone>
				<div className="modal-file-list">{getFileItems()}</div>
			</div>
		</div>
	);
}

export default BillComponent;
